import Vue from 'vue';
import Vuetify from 'vuetify/lib';

// Locale
import { es } from 'vuetify/lib/locale'

Vue.use(Vuetify);

export default new Vuetify({
    lang: {
        current: 'es',
        locales: { es }
      },
    rtl: false,
    theme: {
        default: 'dark',
        disable: false,
        light: false,
        dark: true,
        themes: {
            dark: {
                primary: '#5196F3',
                secondary: '#424242',
                accent: '#FF4081',
                error: '#DF6262',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FB8C00',
            },
        },
    },
});
